
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useRoutines = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ["routines", user?.id],
    queryFn: async () => {
      if (!user) return [];

      // Optimized query with user filter and limited fields
      const { data, error } = await supabase
        .from("routines")
        .select("id, name, created_at, image_url")
        .eq("user_id", user.id)
        .order("created_at", { ascending: false })
        .limit(50);

      if (error) throw error;
      return data || [];
    },
    enabled: !!user,
    staleTime: 30000,
    gcTime: 300000,
  });
};
